import { Field, TextOutput } from 'Components/Core';
import { IFieldProps } from 'Components/Core/Field/types';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import React from 'react';

type WorksheetBatchUpdateEquipmentDisplayFieldProps = Omit<IFieldProps, 'input'>;
/**
 * Provides a field for displaying an equipment selection
 *
 * Currently we just display the equipment code
 */
let WorksheetBatchUpdateEquipmentDisplayField: React.FC<WorksheetBatchUpdateEquipmentDisplayFieldProps> = ({
  value,
  ...otherProps
}) => <Field {...otherProps} input={<TextOutput />} value={value?.Code} />;

WorksheetBatchUpdateEquipmentDisplayField = withInjectedProps(WorksheetBatchUpdateEquipmentDisplayField);

export default WorksheetBatchUpdateEquipmentDisplayField;
export { WorksheetBatchUpdateEquipmentDisplayField };
